/**
 * @memberOf Tee
 * @class Color and parameters to draw shadows behind areas.
 * @param {Tee.Chart} chart The parent chart this shadow object belongs to.
 */
export class Shadow {
	constructor(chart) {
		this.chart = chart
		this.visible = false
		this.blur = 4
		this.color = "rgba(80,80,80,0.75)"
		this.width = 4
		this.height = 4
	}

	prepare(c) {
		if (this.visible) {
			c.shadowBlur = this.blur
			c.shadowColor = this.color
			c.shadowOffsetX = this.width
			c.shadowOffsetY = this.chart.isAndroid ? -this.height : this.height
		} else {
			c.shadowColor = "transparent"
		}
	}

	set(s) {
		this.visible = s.visible
		this.color = s.color
		this.blur = s.blur
		this.width = s.width
		this.height = s.height
	}
}
